import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeftLong = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M2.49565 18.8C1.83478 19.4609 1.83478 20.5295 2.49565 21.1834L12.0572 30.752C12.7181 31.4128 13.7867 31.4128 14.4406 30.752C15.0944 30.0911 15.1015 29.0224 14.4406 28.3686L7.76155 21.6896L36.3127 21.6825C37.2477 21.6825 38 20.9303 38 19.9952C38 19.0601 37.2477 18.3079 36.3127 18.3079L7.76155 18.3079L14.4406 11.6288C15.1015 10.968 15.1015 9.89931 14.4406 9.24546C13.7797 8.59162 12.7111 8.58459 12.0572 9.24546L2.49565 18.8Z" })
});
export default SvgArrowLeftLong;
